module.exports = __webpack_public_path__ + "static/media/telemeddoct.af1542b4.png";